import { getCookieManagerService } from '../services/cookieManager';

export const SNOWPLOW_COOKIE_NAME = 'gen.snowplowCollectorUrl';
export function getSnowplowCollectorUrlOrDefault(defaultUrl: string) {
  const cookieManager = getCookieManagerService();
  const snowplowCollectorUrl = cookieManager.read(SNOWPLOW_COOKIE_NAME);
  return snowplowCollectorUrl || defaultUrl;
}
